<!-- Loader for other page -->
@if (loaderService.loader() && !loaderService.mainLoader()) {
  <section class="loader-container">
    <div class="loader">
      <ion-spinner name="crescent" class="loader-spinner"></ion-spinner>
      <p class="text">{{ loaderService.loaderMessage() }}</p>
    </div>
  </section>
}

<!-- Loader for main page -->
@else if (loaderService.mainLoader()) {
  <section class="main-loader-container">
    <div class="main-loader">
      <img [src]="horizontalLogoSrc" alt="logo" />
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    </div>
  </section>
}
